import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DashboardLayout } from "../layouts/dashboard.layout";
import { ProtectedRoute } from "./protected-route";
import { Dashboard } from "../modules/dashboard";
import { NotFound } from "../modules/404";
import { CustomersRouter } from "../modules/customers/customers.router";
import { UsersRouter } from "../modules/users/users.router";
import { CategoriesRouter } from "../modules/categories/categories.router";
import { ContactsRouter } from "../modules/contacts/contacts.router";
import { ProspectionsRouter } from "../modules/prospections/prospections.router";
import { MailboxesRouter } from "../modules/mailboxes/mailboxes.router";
import { MailMessagesRouter } from "../modules/mail-messages/mail-messages.router";
import { CmsRouter } from "../modules/cms/cms.router";
import { ReportsRouter } from "../modules/reports/reports.router";
import { ArticlesRouter } from "../modules/articles/articles.router";
import { TutoRouter } from "../modules/tuto/tuto.router";
import { ThemesRouter } from "../modules/themes/themes.router";
import { PromptFragmentsRouter } from "../modules/prompt-fragments/prompt-fragments.router";
import { CreatedSitesRouter } from "../modules/created-sites/created-sites.router";
import { CustomerTasksRouter } from "../modules/customer-tasks/customer-tasks.router";
import { NotificationsRouter } from "../modules/notifications/notifications.router";
import { SalesArgumentsRouter } from "../modules/sales-arguments/sales-arguments.router";

export const AdminRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          <Route element={<ProtectedRoute roles={["Any"]} />}>
            <Route path="/" element={<Dashboard />} />
          </Route>
          {CustomersRouter}
          {UsersRouter}
          {CategoriesRouter}
          {ContactsRouter}
          {ProspectionsRouter}
          {MailboxesRouter}
          {MailMessagesRouter}
          {CmsRouter}
          {ReportsRouter}
          {ArticlesRouter}
          {TutoRouter}
          {ThemesRouter}
          {PromptFragmentsRouter}
          {CreatedSitesRouter}
          {CustomerTasksRouter}
          {NotificationsRouter}
          {SalesArgumentsRouter}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
